module.exports = __webpack_public_path__ + "static/img/formImg.f0b358fe.png";